module.exports = "pegasus_template/assets/themelp1/small/8.png";